// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import Link, { LinkPresentationProps, LinkProps } from "@insite/mobius/Link";
import TrashFill from "@store/Library/Components/Toolkit/Icons/Trash/TrashFill";
import { linkGetActionLinkProps } from "@store/Themes/common/props/link";
import React, { FC } from "react";

export interface ProductLineRemoveLinkProps {
    onClick: NonNullable<LinkProps["onClick"]>;
}

export interface ProductLineRemoveLinkStyles {
    link?: LinkPresentationProps;
}

export const productLineRemoveLinkStyles: ProductLineRemoveLinkStyles = {
    link: linkGetActionLinkProps(TrashFill),
};

const styles = productLineRemoveLinkStyles;

const ProductLineRemoveLink: FC<ProductLineRemoveLinkProps> = ({ onClick }) => {
    return (
        <Link {...styles.link} onClick={onClick} data-test-selector="product_removeBtn">
            {translate("Remove")}
        </Link>
    );
};

export default ProductLineRemoveLink;
